<template>
    <div class="access">
        <div class="card pb-4" v-if="ready">
            <div class="card-body text-center">
                <img class="my-4" src="/images/dfc-logo.svg" alt="dfc"/>
                <h3 class="card-title text-center font-weight-bold">Sign in to your workspace</h3>
                <form @submit.prevent="redirect">
                    <div class="form-group d-flex mt-4">
                        <div @click="focusInput" :class="focused ? 'active' : ''" class="custom-input-left">
                            {{ this.host }}
                        </div>
                        <input ref="right-input" @focus="focused = true" @blur="focused = false"
                               placeholder="your_tenant_id" type="text"
                               required
                               class="custom-input-right" v-model="tenant" :readonly="read"/>

                    </div>
                    <button v-if="read" @click="change" type="button" class="mt-2 button btn btn-light">
                        Change
                    </button>
                    <button type="submit" class="mt-2 button btn btn-dark">
                        Continue
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "../Jetstream/Button.vue";
import { useCookies } from "vue3-cookies";

export default {
    name: "Access",
    components: {Button},
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    data(){
        return {
            read: true,
            host: '',
            tenant: '',
            ready: false,
            focused: false
        }
    },
    methods:{
        redirect(){
            this.cookies.set('last_tenant', this.tenant)
            this.$inertia.visit(`/${this.tenant}`);
        },
        focusInput(){
            this.$refs['right-input'].focus();
        },
        change(){
            this.read = false;
            this.focusInput();
        }
    },
    mounted() {
        if( !this.cookies.get('last_tenant')){
            this.tenant = 'app'
        }else{
            this.tenant = this.cookies.get('last_tenant');
        }

        this.host = window.location.origin + "/";
        this.ready = true;
    }
}
</script>

<style lang="scss" scoped>
.access{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.button{
    width: 100%;
}

.access img{
    max-width: 100px;
}

.custom-input-left{
    width: fit-content;
    display: block;
    height: calc(1.6em + 0.75rem + 2px);
    padding: 0.375rem 0rem 0.375rem 0.75rem;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    //background-clip: padding-box;
    border: 1px solid #ced4da;
    border-right: 0;
    border-radius: 0.25rem 0 0 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-input-right{
    display: block;
    height: calc(1.6em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem 0.375rem 0rem;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-left: 0;
    border-radius: 0rem 0.25rem 0.25rem 0rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-input-left.active{
    color: #495057;
    border-color: #5ccbff;
    border-left: 0 !important;
    outline: 0;
    box-shadow: -0.20rem 0 0 0.2rem rgba(0, 150, 219, 0.25);
}

.custom-input-right:focus{
    color: #495057;
    border-color: #5ccbff;
    border-left: 0 !important;
    outline: 0;
    box-shadow: 0.20rem 0 0 0.2rem rgba(0, 150, 219, 0.25);
}
</style>
